import classNames from 'classnames';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import styles from './styles.module.scss';

import { useAuth } from '@/app/providers/AuthContext';
import { useCart } from '@/entities/cart/lib/use-cart';
import { cartStore } from '@/entities/cart/store/cartStore';
import { ProductDetails } from '@/entities/product/ui/ProductDetails/ProductDetails';
import { restaurantStore } from '@/entities/restaurant/store/restaurantStore';
import { AuthModal } from '@/features/auth/ui/AuthModal/AuthModal';
import { OAuthMockCallbackListener } from '@/features/auth/ui/OAuthMockCallbackListener/OAuthMockCallbackListener';
import { Cart } from '@/features/cart/ui/Cart';
import { ServerErrorPage } from '@/pages/ServerErrorPage/ServerErrorPage';
import { formatPrice } from '@/shared/lib/currency';
import { observer } from '@/shared/lib/signal/observer';
import { uiStore } from '@/shared/stores/uiStore';
import { Button } from '@/shared/ui-kit/Button/Button';
import { Drawer } from '@/shared/ui-kit/Drawer/Drawer';
import { ToastProvider } from '@/shared/ui-kit/ToastProvider/ToastProvider';
import { Footer } from '@/widgets/footer/ui/Footer/Footer';

export const BaseLayout = observer(() => {
  const total = cartStore.total.value;
  const hasItems = cartStore.items.value.length > 0;
  const cartOpen = uiStore.cartOpen.value;
  const location = useLocation();
  const { isAuthModalVisible, closeAuthModal } = useAuth();
  const detailsOpen = uiStore.productDetailsOpen.value;
  const detailsProduct = uiStore.productDetailsProduct.value;
  useCart();
  useEffect(() => {
    if (localStorage.getItem('openCartOnNextLoad') === '1') {
      uiStore.openCart();
      localStorage.removeItem('openCartOnNextLoad');
    }
  }, [location.key]);

  useEffect(() => {
    restaurantStore.hydrateFromStorage();
  }, []);

  return (
    <>
      <ToastProvider>
        <OAuthMockCallbackListener />
        <div
          className={classNames(styles.container, {
            [styles.footerShown]: hasItems,
          })}
        >
          <Outlet />
        </div>

        {hasItems && (
          <Footer>
            <Button
              onClick={() => uiStore.openCart()}
              className={styles.footerButton}
            >
              {formatPrice(total)} в корзине
            </Button>
          </Footer>
        )}

        <Cart open={cartOpen} onClose={() => uiStore.closeCart()} />
        <AuthModal open={isAuthModalVisible} onClose={closeAuthModal} />
      </ToastProvider>
      <Drawer open={detailsOpen} onClose={() => uiStore.closeProductDetails()}>
        {detailsProduct && (
          <ProductDetails
            product={detailsProduct}
            onClose={() => uiStore.closeProductDetails()}
          />
        )}
      </Drawer>
      <ServerErrorPage />
    </>
  );
});
